<template>
	<div>
		<form @submit.prevent='logina'>
			<div>
				<!-- 模态框展示方式 1：直接展示 -->
				<div id="exampleModalCenter" v-if="isModalVisible && !isFloating" tabindex="-1">
					<div class="modal-dialog" role="document">
						<div class="modal-content" style="background-color: #1D1D1B;">
							<div class="modal-header border-0 mb-4"> </div>
							<div class="modal-body">
								<div class="text-center" style="color: #FCB42E;">
									<h4 class="mb-3">SIGN UP FOR INFORMATION</h4>
									<p class="mb-4">Get the latest news，updates and developments from Sanmak
										straight to your mailbox</p>
									<div class="row">
										<div class="col-md-12 col-md  mb-4">
											<input type="text" class="form-control width_10"
												placeholder="Enter your name" v-model="username"
												onblur="this.placeholder='Enter your name'"
												onfocus="this.placeholder=''">
										</div>
										<div class="col-md-12 col-md mb-4">
											<input type="text" class="form-control width_10"
												placeholder="Enter your email address" v-model="password"
												onblur="this.placeholder='Enter your email address'"
												onfocus="this.placeholder=''">
										</div>
										<div class="col-md-12 col-md mb-4">
											<button type="submit" class="btn custom-btn-primary width_10"
												style="width: 180px;">Sign Up</button>
										</div>

									</div>
								</div>
								<p class="text-center text-muted mb-4"> We promise to never share your details.</p>

							</div>
						</div>
					</div>
				</div>

				<!-- 模态框展示方式 1：悬浮展示 -->
				<div id="exampleModalCenter" class="modal" style="background: #202C40; "
					v-if="isModalVisible && isFloating&&!isLoginPage" tabindex="-1">
					<!-- 登录页 -->
					<div class="modal-dialog" role="document" style="width: 720px;max-width:800px;">
						<div class="modal-content" style="background-color: #1D1D1B;width: 720px;height: 600px;">
							<div class="modal-header border-0">
								<button type="button" class="close" @click="closeFloatingModal">
									<span>×</span>
								</button>
							</div>
							<div class="modal-body">
								<div class="text-center " style="color: #FCB42E;">
									<h4 class="mb-3">Login</h4>


								</div>
								<div>
									<div class="row ">
										<div
											style="text-align:left;line-height:1;font-size:15px;line-height: 1.5;color: #A2A2A2;">
											<p>If you already are a Sanmak customer and your email address is included
												in
												the Sanmak ERP system, click "Get Code." The system will directly send a
												verification code to your email address. Copy this code for this login
												session; you will need to obtain a new dynamic verification code for
												subsequent logins.
											</p>
											<p style="height: 20px;"></p>
											<p>If you are not a Sanmak customer, or your email address is not included
												in
												the Sanmak ERP system, clicking "Get Code" will prompt you to contact
												our
												sales representative. You will only be able to obtain a verification
												code
												for member login after your email address is added to the verification
												code.
											</p>
										</div>

									</div>
									<div class="row" style="padding-left: 0;">
										<div class="row"
											style="margin-top:20px;color:#A2A2A2;margin-bottom:5px; font-size: 15px;">
											E-Mail
										</div>
										<br>

									</div>
									<div class="row " style="text-align: left;">
										<div class="col-md " style="width:320px">
											<input type="text" class="form-control form-control-sm"
												placeholder="Email address" v-model="email"
												onfocus="this.placeholder=''" onblur="this.placeholder='Email address'">
										</div>
										<div style="text-align:right">
											<button type="button" class="btn footer-btn-primary"
												style="margin-left:10px;color:black;" @click="getCode">
												Get code
											</button>
										</div>
									</div>
									<div class="row"
										style="margin-top:20px;margin-bottom:5px;color:#A2A2A2;font-size: 15px;">Dynamic
										Code
									</div>
									<div class="row">
										<input type="text" class="form-control form-control-sm"
											style="display:block;width:560px"
											placeholder="Enter your dynamic verification code" v-model="password"
											onfocus="this.placeholder=''"
											onblur="this.placeholder='Enter your dynamic verification code'">
									</div>
									<div class="row">
										<div class="col-md-12 col-md mb-4" style="margin-top:35px;">
											<!-- <button type="submit" class="btn custom-btn-primary "
											style="width: 100px;color:black;">Login</button> -->
											<label class="btn"
												style="width: 100px;  border: 1px solid;border-color: #FCB42E;border-radius: 4px; color: #FCB42E;"
												@click="logina">
												login</label>
											<label class="btn"
												style="width: 100px; margin-left:15px; border: 1px solid;border-color: #FCB42E;border-radius: 4px; color: #FCB42E;"
												@click="closeFloatingModal">
												Exit</label>
										</div>
									</div>
								</div>
								<!-- <p class="text-center text-muted mb-4" > </p> -->
								<!-- <label for="" style="height:35px"></label> -->
								<div style=" text-align: right;">
									<!-- <label style="height:35px;color: #1F47A3;" @click="OpenLearnMore"> Learn More ...</label> -->
									<a href="#" @click="OpenLearnMore" style="color: #1F47A3;">Learn More ...</a>
									<!-- <label class="btn"
												style="width: 100px; margin-left:15px; border: 1px solid;border-color: #FCB42E;border-radius: 4px; color: #FCB42E;"
												@click="closeFloatingModal">
												Exit</label> -->
								</div>


							</div>
						</div>
					</div>
				</div>
				<div id="exampleModalCenter" class="modal" style="background: #202C40;"
					v-if="isModalVisible && isFloating&&isLoginPage" tabindex="-1">
					<!-- 联系页 -->
					<div v-if="isLoginPage" class="modal-dialog" role="document">
						<div class="modal-content" style="background-color: #1D1D1B;">
							<div class="modal-header border-0">
								<button type="button" class="close" @click="closeFloatingModal">
									<span>×</span>
								</button>
							</div>
							<div class="modal-body">
								<div class="text-center" style="color: #FCB42E;">
									<h4 class="mb-3">Contact</h4>
									<div class="row">
										<div style="text-align:left;line-height:1;color:#A2A2A2;font-size:13px;">
											Your information has not been included by sanmak yet. Please contact
											the salesperson to update, and then you can login to view the latest
											information.
										</div>

									</div>
									<div class="row">
										<div class="row" style="margin-top:8px;color:white;text-align:left">E-mail</div>
										<div class="col-md-12 " style="margin-top:8px;margin-bottom:0px; "><input
												type="text" class="form-control form-control-sm"
												style="color: black; border-radius: 4px;"
												placeholder="Please enter your business email address" v-model="email"
												onfocus="this.placeholder=''"
												onblur="this.placeholder='Please enter your business email address'">
											<div class="row" style="margin-top:8px;color:white;text-align:left">Contact
												Us
											</div>
											<!-- <div class="col-md-12 col-md mb-4" style="margin-top:8px;">
										<input type="text" class="form-control form-control-sm" placeholder="Select salesman" v-model="sanEmail">
									</div> -->
											<!-- <el-select v-model="selectValue" placeholder="请选择" style="height: 30px;width: 440px;" @change="handleChange">
											<el-option v-for="saler in salerData" :key="saler.id" :label="saler.code"
												:value="saler.code">
												<span style="display: flex; align-items: center;">
													<i :class="saler.remark" style="margin-right: 8px;"></i>
													<span>{{ saler.code }}</span>
												</span>
											</el-option>
										</el-select> -->
											<DropDownTree :data="salerData" :defaultProps="dropProps"
												:selectValue="selectValue" ref="typeTree" :isSearch="0"
												@update:selectNode="typeSelectValueChange">
											</DropDownTree>
											<!-- <select class="minimal col-md-12 col-md mb-4 form-control form-control-sm abced"
											style="margin-top:8px;margin-left:0px;background-image: url('../assets/img/main/路径 3408@2x.png.png');
									background-repeat: no-repeat;
									background-position: left center;
									" @change="handleChange">
											<option disabled selected value="" style="display:none;color: whitesmoke;">

											</option>
											<option id="selectSaler" v-for="saler in salerData" :key="saler.id"
												:value="saler.code">
												{{saler.code}}
											</option>
										</select> -->

										</div>
										<div class="col-md-12 col-md mb-4" style="margin-top:8px;">
											<button type="button" class="btn custom-btn-primary "
												style="width: 120px;color:black;" @click="contactSale">Send
												Email</button>

											<label class="btn"
												style="width: 120px; margin-left:15px; border: 1px solid;border-color: #FCB42E;border-radius: 4px; color: #FCB42E;"
												@click="closeFloatingModal">
												Exit
											</label>
										</div>
									</div>


								</div>
								<!-- <p class="text-center text-muted mb-4" @click="showBox('emailSucessPop')"> 123</p> -->
								<label for="" style="height:35px"></label>
							</div>
						</div>
					</div>
				</div>

				<!-- 内层弹窗 -->
				<div v-show="showInner" class="inner-modal">
					<div class="inner-modal-content" style="width: 730px;height: 600px;">
						<div class="inner-modal-header" style="text-align: center;">
							<h4 style="padding-left: 260px;color: #FCB42E;padding-top: 5px;">Learn More</h4>
							<button type="button" class="close" @click="showInner = false"><span>×</span></button>
						</div>
						<div class="inner-modal-body "
							style="text-align: left;font-size: 15px;padding-left: 40px;padding-right: 30px;">
							<slot name="inner-content">
								<p style="padding-top: 25px;color: #FCB42E;font-weight: bold;font-size: 16px;">Sanmak
									Membership Privileges Introduction:</p>

								<p style="padding-top: 20px;">Level 1: View all newly added products;</p>

								<p style="padding-top: 10px;">Level 2: View all products from 3 months ago;</p>

								<p style="padding-top: 10px;">Level 3: View all products from 6 months ago;</p>

								<p style="padding-top: 10px;">Level 4: View all products from 9 months ago;</p>

								<p style="padding-top: 10px;">Level 5: View all products from 12 months ago.</p>


								<p style="padding-top: 30px; color: #FCB42E;font-weight: bold;font-size: 16px;">VIP
									Center:</p>

								<p style="padding-top: 20px;">1. Members can view all new products added since last
									login in the VIP Center;</p>

								<p style="padding-top: 10px;">2. Members can view order progress in the VIP Center;</p>

								<p style="padding-top: 10px;">3. OEM/ODM customers can view the progress of new product
									projects in the VIP Center;</p>

								<p style="padding-top: 10px;">4. Members can save new products in the VIP Center and
									send them to info@sanmak.com </p>
								<p style="padding-top: 10px;">&nbsp;&nbsp;&nbsp;&nbsp;for price inquiries with only one click.</p>
							</slot>
						</div>
					</div>
				</div>
			</div>
		</form>

	</div>


</template>


<script>
	import { mapState, mapActions } from 'vuex';
	import { sendMail } from "@/api/rbac/main";
	import DropDownTree from '/src/components/common/DropDownTree.vue';
	import { getUserInfo, getSalerTreeNum } from "@/api/rbac/user";
	// import axios from 'axios'
	export default {
		data() {
			return {
				isLoginPage: false,//false登录，true联系我们
				userID: 0,
				username: '',
				email: '',
				password: '',
				dCode: '',
				isSanmakUser: false,
				stores: {
					linkPerson: []
				},
				sanEmail: '',
				showPopsucess: 0,
				isDropdown: false,
				selectValue: '',
				salerData: [],
				dropProps: {
					children: "children",
					label: "name",
				},
				showInner: false,
			};
		},
		components: {
			DropDownTree,
		},
		computed: {
			...mapState('modal', ['showModal']),

			isModalVisible() {
				return this.showModal;
			},
			isFloating() {
				return this.$store.state.modal.isFloating; // 判断是否为悬浮模式
			},
		},
		mounted() {

		},
		watch: {
			showModal(nval) {
				if (nval == false) {
					this.isLoginPage = false;
				}
			},

		},
		methods: {
			...mapActions('modal', ['closeModal']),
			...mapActions('modal', ['closeFloatingModal']),

			sendMail1() {
				try {
					let code = Math.floor(100000 + Math.random() * 900000);
					const email = {

						toMail: this.stores.linkPerson[0].code,
						body: `<head>
<meta charset='UTF-8'>
    <base target="_blank" />
    <style type="text/css">::-webkit-scrollbar{ display: none; }</style>
    <style id="cloudAttachStyle" type="text/css">#divNeteaseBigAttach, #divNeteaseBigAttach_bak{display:none;}</style>
    <style id="blockquoteStyle" type="text/css">blockquote{display:none;}</style>
    <style type="text/css">
        body{font-size:14px;font-family:arial,verdana,sans-serif;line-height:1.666;padding:0;margin:0;overflow:auto;white-space:normal;word-wrap:break-word;min-height:100px}
        td, input, button, select, body{font-family:Helvetica, 'Microsoft demo', verdana}
        pre {white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word;width:95%}
        th,td{font-family:arial,verdana,sans-serif;line-height:1.666}
        img{ border:0}
        header,footer,section,aside,article,nav,hgroup,figure,figcaption{display:block}
        blockquote{margin-right:0px}
        </style>
    </head>
    <body tabindex="0" role="listitem">
    <table width="700" border="0" align="center" cellspacing="0" style="width:700px;">
        <tbody>
        <tr>
            <td>
                <div style="width:700px;margin:0 auto;border-bottom:1px solid #ccc;margin-bottom:30px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="700" height="39" style="font:12px Tahoma, Arial, 宋体;">
                        <tbody><tr><td width="210"></td></tr></tbody>
                    </table>
                </div>
                <div style="width:680px;padding:0 10px;margin:0 auto;">
                    <div style="line-height:1.5;font-size:20px;margin-bottom:25px;color:#4d4d4d;">
                        <strong style="display:block;margin-bottom:20px;">Dear ${this.stores.linkPerson[0].name}：</strong>
                        <strong style="display:block;margin-bottom:20px;">
                           Please enter your code in the input box: <span style="color:#f60;font-size: 24px">${code}</span>，to complete this step.
                        </strong>
                    </div>
                    <div style="margin-bottom:30px;">
                        <small style="display:block;margin-bottom:20px;font-size:15px;">
                            <p style="color:#747474;">
                               Note: The staff will not ask you for this code, please do not disclose it.
                            </p>
                        </small>
                    </div>
                </div>
                <div style="width:700px;margin:0 auto;">
                    <div style="padding:10px 10px 0;border-top:1px solid #ccc;color:#747474;margin-bottom:20px;line-height:1.3em;font-size:15px;">
                        <p>This is a system email, no reply.<br>
                            Please keep your email safe to prevent your account from being stolen.
                        </p>
                        <p>Sanmak Lighting</p>
                    </div>
                </div>
            </td>
        </tr>
        </tbody>
    </table>
    </body>`,
						subject: 'your dynamic code'
					}
					sendMail(email).then((res) => {
						if (res.data == 'ok') {
							this.dCode = code;
							alert("Your code have been sent, please check your email.")
						}
						else {
							this.dCode = null;
						}
					});
				} catch (error) {
					console.log(error);
				}
			},
			getCode() {
				// event.preventDefault();
				if (this.email == null || this.email == "") {
					alert("enter the email")
				}
				else {
					try {
						const lastAtIndex = this.email.lastIndexOf('@');
						if (lastAtIndex === -1) {
							// 如果没有找到@符号，返回整个字符串或空字符串，根据需求
							return alert('Email format incorrect');
						}
						// const uName = this.email.substring(0, lastAtIndex);
						getUserInfo({ strWhere: ` and a.code='${this.email}'` }).then((res) => {
							this.stores.linkPerson = res.data;
							console.log(res.data)
							if (this.stores.linkPerson.length == 0) {
								this.isLoginPage = true;
								//获取三锦的业务员
								getSalerTreeNum({ strWhere: ' and a.isBus=1 ' }).then((resSaler) => {
									this.salerData = resSaler.data;
									// this.salerData.forEach(saleEle => {
									// if (saleEle.state == 0) {
									// 	saleEle.code = 'el-icon-folder-opened'
									// }
									// else if (saleEle.state == 1) {
									// 	saleEle.code = 'el-icon-user'
									// }
									// else {
									// 	saleEle.code = 'el-icon-s-custom'
									// }
									// });
								})
								// getSalerTreeNum({ strWhere: ' and a.isBus=1 and a.isCus=0' }).then((resSaler) => {
								// 	this.salerData = resSaler.data;
								// 	this.salerData.forEach(saleEle => {
								// 		if (saleEle.sexID == 1) {
								// 			saleEle.remark = 'el-icon-user'
								// 		}
								// 		else {
								// 			saleEle.remark = 'el-icon-s-custom'
								// 		}
								// 	});
								// })
							}
							else {
								// for (let index = 0; index < this.stores.linkPerson.length; index++) {
								// 	var element = this.stores.linkPerson[index];
								// 	this.username = element.linkMan;
								// }
								// this.username=this.state.linkPerson[0].name

								this.sendMail1();

								this.isLoginPage = false;
							}
						})
						// getLinkMan1({ strEmail: this.email }).then((res) => {
						// 	this.stores.linkPerson = res.data.data;
						// 	if (this.stores.linkPerson.length == 0) {
						// 		this.isLoginPage = true;
						// 		//获取三锦的业务员
						// 		getSaler().then((resSaler) => {
						// 			this.salerData = resSaler.data.data;
						// 		})
						// 	}
						// 	else {

						// 		for (let index = 0; index < this.stores.linkPerson.length; index++) {
						// 			var element = this.stores.linkPerson[index];
						// 			this.username = element.linkMan;
						// 		}
						// 		this.sendMail1();
						// 		this.isLoginPage = false;
						// 	}
						// });



					} catch (error) {
						console.log(error);
					}
				}
			},
			// loadLinkList() {
			// 	getLinkMan1({strEmail:this.username}).then((res) => {

			// 		this.stores.linkMan = res.data.data;
			// 		for (var item in this.stores.linkMan) {
			// 			alert(item.linkMan)
			// 		}
			// 	});
			// },
			logina() {
				//  这里可以添加简单的验证或调用API进行登录验证
				if (this.email == null || this.email == '' || this.email == undefined) {
					alert("Email is empty");
				}
				else if (this.stores.linkPerson.length == 0 || this.stores.linkPerson[0].id == 0) {
					alert("Please get the dynamic code");
				}
				else if (this.dCode == null || this.dCode == '' || this.dCode == undefined) {
					alert("Please get the dynamic code");
				}
				else {
					if (this.password != this.dCode) {
						alert("dynamic code error!");
					}
					else {
						// for (let index = 0; index < this.stores.linkPerson.length; index++) {
						// 	var element = this.stores.linkPerson[index];
						// 	this.username=element.linkMan;
						// }

						const user = this.stores.linkPerson[0]; // 示例用户信息，实际应用中应从表单获取或API响应中获取
						this.$store.dispatch('login', user); // 调用login action并传递用户信息
						// this.$store.commit('SET_USER', user);
						this.closeFloatingModal();
						this.$router.push('/', () => { }, () => { });
					}
				}
				// 		if (this.stores.linkPerson.length>0&&this.password=='123456') {

				// 			for (let index = 0; index < this.stores.linkPerson.length; index++) {
				// 				var element = this.stores.linkPerson[index];
				// 				this.username=element.linkMan;
				// 			}
				// 			const user = { username: this.username,email:this.email, token: 'exampleToken' }; // 示例用户信息，实际应用中应从表单获取或API响应中获取
				//    this.$store.dispatch('login', user); // 调用login action并传递用户信息
				// 		// this.$store.commit('SET_USER', user);
				// 		this.closeFloatingModal();
				// 		this.$router.push('/',()=>{},()=>{});
				// 		}
				// 		else{
				// 			alert("Invalid username or password");
				// 		}
			},
			handleChange(value) {
				this.sanEmail = value; // 获取选中的值
			},
			// 联系业务员
			contactSale() {
				try {
					const email = {
						toMail: this.sanEmail,
						body: `<head><h3>尊敬的sanmak:</h3></head><body><div>希望能与贵司合作，请联系，邮箱：${this.email}</div></body>`,
						subject: '合作申请函'
					}
					sendMail(email).then((res) => {
						if (res.data == 'ok') {
							alert("Send success")
							this.closeFloatingModal();
						}
						else {
							alert("Fail to send")
						}
					});
				} catch (error) {
					alert("Fail to send")
				}
			},
			//打开活动规则页面
			showpopup() {
				this.showPopsucess = 1;
			},
			//关闭活动规则页面
			closepopup() {
				this.showPopsucess = 0;
			},

			typeSelectValueChange(value) {
				this.sanEmail = value.code
				// this.selectValue = value;
			},
			OpenLearnMore() {
				this.showInner = true;
			},
		},

	};
</script>

<style scoped>
	@import '../assets/css/main.css';

	input::placeholder {
		color: lightgray;
		/* 设置占位符文字颜色为灰色 */
		font-size: 14px;
		/* 可选：设置字体大小 */
	}

	.modal {
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		z-index: 1000;
	}

	.showPop {
		display: block;
		position: fixed;
		font-size: 24px;
		height: 240px;
		width: 360px;
		/* background-color: linear-gradient(180deg,#2f2f2f 0%,#191919 100%); */

		background: linear-gradient(180deg, #2f2f2f 0%, #191919 100%);
		border-radius: 0rem;
		box-shadow: opx 3px 6px 1px rgba(0, 0, 0, 0.16);
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		z-index: 1000;
	}

	:deep(.el-input__inner) {
		height: 30px !important;
		line-height: 30px;
	}

	:deep(.el-select-width) {
		width: 440px !important;
	}

	/* 新增内层弹窗样式 */
	.inner-modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.3);
		z-index: 1001;
		/* 确保在父模态框之上 */
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.inner-modal-content {
		background: #1D1D1B;
		padding: 20px;
		border-radius: 8px;
		min-width: 300px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	}

	.inner-modal-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 15px;
	}
</style>